// import Swiper JS
import Swiper from 'swiper'

export default function initStepperSlider() {
  const swiperContainers = document.querySelectorAll('.stepper-slider')

  swiperContainers.forEach((swiperContainer) => {
    const swiper = new Swiper(swiperContainer, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      allowTouchMove: false,
    })

    const prevButton = swiperContainer.parentElement.querySelector(
      '.stepper-slider__prev-button'
    )
    const nextButton = swiperContainer.parentElement.querySelector(
      '.stepper-slider__next-button'
    )
    const iconButtons = swiperContainer.parentElement.querySelectorAll(
      '.stepper-slider__navigation-item'
    )

    if (prevButton) {
      prevButton.addEventListener('click', () => {
        swiper.slidePrev()
      })
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => {
        swiper.slideNext()
      })
    }

    iconButtons.forEach((button, index) => {
      button.addEventListener('click', () => {
        swiper.slideTo(index)
      })
    })

    swiper.on('slideChange', function () {
      iconButtons.forEach((button, index) => {
        if (index === swiper.activeIndex) {
          button.classList.add('stepper-slider__navigation-item--active')
        } else {
          button.classList.remove('stepper-slider__navigation-item--active')
        }
      })

      if (prevButton) {
        if (swiper.isBeginning) {
          prevButton.classList.add('stepper-slider__button--disabled')
        } else {
          prevButton.classList.remove('stepper-slider__button--disabled')
        }
      }

      if (nextButton) {
        if (swiper.isEnd) {
          nextButton.classList.add('stepper-slider__button--disabled')
        } else {
          nextButton.classList.remove('stepper-slider__button--disabled')
        }
      }
    })

    // Initial state of buttons
    if (prevButton && swiper.isBeginning) {
      prevButton.classList.add('stepper-slider__button--disabled')
    }
    if (nextButton && swiper.isEnd) {
      nextButton.classList.add('stepper-slider__button--disabled')
    }
  })
}
